import axios from "axios";
import toast from "react-hot-toast";
import { refreshPage } from "../Utils/Common";

// Set up a global response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle 401 error
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      toast.error("Unauthorized. Logging you out...", { autoClose: 5000 });
      setTimeout(() => {
        window.location.href = "/";
        refreshPage();
      }, 1000);
    }

    return Promise.reject(error);
  }
);

const DATE_KEY    = /(date|_on$|birthdate|expir|deadline)/i;
const ID_KEY      = /(_ids?$|^ids?$)/i;
const NUMERIC_KEY = /(amount|price|subtotal|total|quantity|qty|fee|percent|balance|vat|tax|discount|cost|rate|wht|stock|weight)/i;

const emptyReplacement = (key) => {
  if(DATE_KEY.test(key)) return null; // nullable date
  if(ID_KEY.test(key)) return null; // non selected
  if(NUMERIC_KEY.test(key)) return 0; // numeric
  return undefined; // leave ""
};

const scrubData = (value, key = "") => {
  if(Array.isArray(value)) return value.map((v) => scrubData(v, key));
  if(value && typeof value=="object"){
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, scrubData(v, k)])
    );
  }

  if(value===""){
    const r = emptyReplacement(key);
    return r === undefined ? value : r;
  }

  return value;
};


axios.interceptors.request.use((config) => {
  if(config.data instanceof FormData){
    const rebuilt = new FormData();
    for (const [rawKey, val] of config.data.entries()){
      const isArrayField = /\[\]$/.test(rawKey);
      const key = rawKey.replace(/\[\]$/, "");
      if(val === ""){
        const r = emptyReplacement(key);
        // Array-suffixed fields (e.g. fee_expense_type_ids[]) carry one entry
        // per row, positionally matched against sibling arrays (fee_descriptions[],
        // fee_amounts[], ...). Dropping an empty entry here shifts every later
        // row's values into the wrong slot, so always keep the slot for these.
        if (r === null && !isArrayField) continue;
        rebuilt.append(rawKey, r === undefined || r === null ? "" : String(r));
      } else {
        rebuilt.append(rawKey, val);
      }
    }
    config.data = rebuilt;
  } else if(config.data && typeof config.data == "object"){
    config.data=scrubData(config.data);
  }

  if(config.params && typeof config.params == "object"){
    config.params = scrubData(config.params);
  }
  return config;
});

const getAPIKey = () => {
  const userStr = localStorage.getItem("api-key");
  if (userStr) return userStr;
  else return null;
};

const getAPIKey2 = () => {
  const userStr = localStorage.getItem("api-key2");
  if (userStr) return userStr;
  else return null;
};

// CHANGED: from static variables to functions
const getConfig = () => ({
  "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
  "user-key": getAPIKey(),
  "Content-Type": "application/json",
});

const getConfig2 = () => ({
  "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
  "user-key": getAPIKey2(),
  "Content-Type": "application/json",
});

const getConfigFormData = () => ({
  "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
  "user-key": getAPIKey(),
  "Content-Type": "multipart/form-data",
});

// API Axios Get Call.
export const getAPICall = (url, data, type) => {
  if (type === "potato") {
    return axios.get(url, { headers: getConfig2(), params: data });
  } else {
    return axios.get(url, { headers: getConfig(), params: data });
  }
};

// Potato Corner
export const getAPICall2 = (url, data) => {
  return axios.get(url, { headers: getConfig2(), params: data });
};

// API Axios Post Call.
export const postAPICall = (url, data, isFormData=false) => {
  if (isFormData) {
    return axios.post(url, data, { headers: getConfigFormData() });
  } else {
    return axios.post(url, data, { headers: getConfig() });
  }
};

// API Axios Post Call.
export const postAPICall2 = (url, data, config) => {
  return axios.post(url, data, { headers: config });
};

// API Axios Put Call.
export const putAPICall = (url, data, type) => {
  if (type === "potato") {
    return axios.put(url, data, { headers: getConfig2() });
  } else {
    return axios.put(url, data, { headers: getConfig() });
  }
};

// API Axios Delete Call.
export const deleteAPICall = (url, type) => {
  if (type === "potato") {
    return axios.delete(url, { headers: getConfig2() });
  } else {
    return axios.delete(url, { headers: getConfig() });
  }
};